export enum LinkVariant {
  TOP_PRIMARY = 'topPrimary',
  TOP_SECONDARY = 'topSecondary',
}
